import { render } from "./VpnDetails.vue?vue&type=template&id=bd982d88&scoped=true"
import script from "./VpnDetails.vue?vue&type=script&lang=js"
export * from "./VpnDetails.vue?vue&type=script&lang=js"

import "./VpnDetails.vue?vue&type=style&index=0&id=bd982d88&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd982d88"]])

export default __exports__